(() => {

  /************************************************************
   *  🔥 FLAGS
   ************************************************************/
  let isAppending = false;
  let loading = false;
  let nextUrl = "";
  let io = null;

  /************************************************************
   *  🔥 LOADER (3 dots)
   ************************************************************/
  const loader = document.createElement("div");
  loader.id = "infinite-loader";
  loader.innerHTML = `
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  `;
  loader.style.display = "none";
  document.body.appendChild(loader);


  /************************************************************
   *  🔥 GET next_url (template + JSON hybrid)
   ************************************************************/
  function getNextUrl(doc = document) {
    const tpl = doc.querySelector("#PaginationData");
    if (tpl && tpl.dataset.nextUrl) return tpl.dataset.nextUrl;

    const jsonNode = doc.querySelector("script[data-pagination-json]");
    if (!jsonNode) return null;

    try {
      return JSON.parse(jsonNode.textContent).next_url || null;
    } catch {
      return null;
    }
  }


  /************************************************************
   *  🔥 RESTORE GRID + SCROLL ON BACK
   ************************************************************/
  function restoreState() {
    if (performance.navigation.type !== 2) return;

    const html = sessionStorage.getItem("collection-html");
    const scroll = sessionStorage.getItem("collection-scroll-pos");
    if (!html || !scroll) return;

    const gridContainer = document.querySelector("#CollectionProductGrid");
    if (!gridContainer) return;

    gridContainer.innerHTML = html;
    setTimeout(() => window.scrollTo(0, +scroll), 40);
  }


  /************************************************************
   *  🔥 PREFETCH LA PAGE SUIVANTE (accélère 30%)
   ************************************************************/
  function prefetchUrl(url) {
    if (!url) return;

    const link = document.createElement("link");
    link.rel = "prefetch";
    link.href = url;
    document.head.appendChild(link);
  }


  /************************************************************
   *  🔥 LOAD NEXT PAGE
   ************************************************************/
  async function loadNext() {
    if (!nextUrl || loading) return;

    loading = true;
    isAppending = true;
    loader.style.display = "flex";

    try {
      const res = await fetch(nextUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const grid = document.querySelector("#main-collection-product-grid");
      const incoming = doc.querySelectorAll(
        "#main-collection-product-grid .js-product-listing"
      );

      incoming.forEach(el => {
        el.classList.add("fade-in-product");
        grid.appendChild(el);
      });

      const newUrl = getNextUrl(doc);
      nextUrl = newUrl || "";

      if (nextUrl) prefetchUrl(nextUrl);

      if (!nextUrl && io) io.disconnect();

    } catch (e) {
      console.warn("[InfiniteScroll] Error:", e);
    }

    setTimeout(() => {
      isAppending = false;
      loader.style.display = "none";
    }, 80);

    loading = false;
  }


  /************************************************************
   *  🔥 INIT INFINITE SCROLL
   ************************************************************/
  function initInfiniteScroll() {
    const sentinel = document.querySelector("#infinite-scroll-sentinel");
    if (!sentinel) return;

    nextUrl = getNextUrl() || "";
    if (!nextUrl) return;

    prefetchUrl(nextUrl);

    if (io) io.disconnect();

    io = new IntersectionObserver(
      entries => {
        if (entries.some(e => e.isIntersecting)) loadNext();
      },
      { rootMargin: "600px 0px" }
    );

    io.observe(sentinel);
  }


  /************************************************************
   *  🔥 MutationObserver → re-init après filtres
   ************************************************************/
  function setupMutationObserver() {
    const container = document.querySelector("#CollectionProductGrid");
    if (!container) return;

    const mo = new MutationObserver(mutations => {
      if (isAppending) return;

      for (let m of mutations) {
        if (m.addedNodes.length || m.removedNodes.length) {
          setTimeout(initInfiniteScroll, 100);
          return;
        }
      }
    });

    mo.observe(container, { childList: true, subtree: true });
  }


  /************************************************************
   *  🔥 SAVE STATE ON LEAVE
   ************************************************************/
  function saveState() {
    const grid = document.querySelector("#CollectionProductGrid");
    if (!grid) return;

    sessionStorage.setItem("collection-scroll-pos", window.scrollY);
    sessionStorage.setItem("collection-html", grid.innerHTML);
  }


  /************************************************************
   *  🔥 BOOT
   ************************************************************/
  function boot() {
    restoreState();
    initInfiniteScroll();
    setupMutationObserver();
    window.addEventListener("beforeunload", saveState);
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot)
    : boot();

})();
